<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="18.884" height="13.5" viewBox="0 0 18.884 13.5" class="scaling-svg">
      <g data-name="Group 52" transform="translate(-826.116 -690.25)">
        <path
          d="M11.849,12.227a.319.319,0,0,0,.319-.362l-.319-2.271a.319.319,0,0,0-.091-.183L4.872,2.6a1.522,1.522,0,0,0-2.347-.021A1.622,1.622,0,0,0,1.972,3.73a1.681,1.681,0,0,0,.575,1.182c.266.261.627.619.627.619h0l6.26,6.191a.319.319,0,0,0,.165.086l2.193.418a.362.362,0,0,0,.058,0Zm-.615-2.443.239,1.729L9.811,11.2,3.621,5.076l-.627-.62a1.075,1.075,0,0,1-.386-.725,1.012,1.012,0,0,1,.364-.7.893.893,0,0,1,1.451.02ZM3.4,5.3Z"
          transform="translate(824.444 690.522)"
          stroke="currentColor"
          stroke-width="0.6"
        />
        <g transform="translate(830 706) rotate(-90)">
          <g data-name="Icon_rating" transform="translate(2.25 3)">
            <path d="M0,1.5a1.5,1.5,0,0,1,3,0v9a1.5,1.5,0,0,1-3,0Z" transform="translate(10.5)" />
            <path data-name="Path" d="M0,1.5a1.5,1.5,0,0,1,3,0v6a1.5,1.5,0,0,1-3,0Z" transform="translate(5.25 3)" />
            <path
              data-name="Path"
              d="M1.5,0A1.5,1.5,0,0,0,0,1.5V3A1.5,1.5,0,0,0,3,3V1.5A1.5,1.5,0,0,0,1.5,0Z"
              transform="translate(0 7.5)"
            />
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class EditAttributesIcon extends Vue {}
</script>

<style>
</style>
